var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockCompetition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_170405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7493 6.66699C10.7493 6.25278 10.4136 5.91699 9.99935 5.91699C9.58514 5.91699 9.24935 6.25278 9.24935 6.66699L10.7493 6.66699ZM12.4993 11.5837C12.9136 11.5837 13.2493 11.2479 13.2493 10.8337C13.2493 10.4194 12.9136 10.0837 12.4993 10.0837V11.5837ZM2.03083 2.12301C1.70738 2.38176 1.65494 2.85373 1.9137 3.17718C2.17245 3.50063 2.64442 3.55307 2.96787 3.29431L2.03083 2.12301ZM5.0512 1.62764C5.37465 1.36889 5.42709 0.896917 5.16833 0.573471C4.90958 0.250024 4.43761 0.197583 4.11416 0.456341L5.0512 1.62764ZM17.0308 3.29431C17.3543 3.55307 17.8262 3.50063 18.085 3.17718C18.3438 2.85373 18.2913 2.38176 17.9679 2.12301L17.0308 3.29431ZM15.8845 0.456341C15.5611 0.197583 15.0891 0.250024 14.8304 0.573471C14.5716 0.896917 14.624 1.36889 14.9475 1.62764L15.8845 0.456341ZM9.99935 9.58366H9.24935H9.99935ZM9.24935 6.66699L9.24935 9.58366H10.7493V6.66699L9.24935 6.66699ZM17.5827 10.0003C17.5827 14.1885 14.1875 17.5837 9.99935 17.5837V19.0837C15.0159 19.0837 19.0827 15.0169 19.0827 10.0003H17.5827ZM9.99935 17.5837C5.81119 17.5837 2.41602 14.1885 2.41602 10.0003H0.916016C0.916016 15.0169 4.98276 19.0837 9.99935 19.0837V17.5837ZM2.41602 10.0003C2.41602 5.81217 5.81119 2.41699 9.99935 2.41699V0.916992C4.98276 0.916992 0.916016 4.98374 0.916016 10.0003H2.41602ZM9.99935 2.41699C14.1875 2.41699 17.5827 5.81217 17.5827 10.0003H19.0827C19.0827 4.98374 15.0159 0.916992 9.99935 0.916992V2.41699ZM2.96787 3.29431L5.0512 1.62764L4.11416 0.456341L2.03083 2.12301L2.96787 3.29431ZM17.9679 2.12301L15.8845 0.456341L14.9475 1.62764L17.0308 3.29431L17.9679 2.12301ZM11.2493 11.5837H12.4993V10.0837H11.2493V11.5837ZM9.24935 9.58366C9.24935 10.6882 10.1448 11.5837 11.2493 11.5837V10.0837C10.9732 10.0837 10.7493 9.8598 10.7493 9.58366H9.24935Z",
    fill: "url(#paint0_radial_1_170405)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_170405",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.86927 17.0035) rotate(-42.5836) scale(22.3599 60.4939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D56EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0640B9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_170405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockCompetition);
export default __webpack_public_path__ + "static/media/clockCompetition.6ce0efcdd54d26ada84c90c8c7b6e9a2.svg";
export { ForwardRef as ReactComponent };